import React, { Component } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import CheckBox from "../../inputs/CheckBox";
import Textarea from "../../inputs/Textarea";
import TextInput from "../../inputs/TextInput";
import { Button } from "../../util/Clickable";
import * as normalize from "../../util/Normalizer";
import { IntlHTML, IntlText } from "../../util/Text";
import * as validate from "../../util/Validator";

class ArtistForm extends Component {
  state = {
    loading: false,
  };

  onSubmit = (values) => {
    this.setState({
      loading: true,
    });
    return this.props.onSubmit(values).then(({ value, action }) => {
      if (value.status < 300) {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.props.onSuccess &&
              this.props.onSuccess(value.data, value.response);
          },
        );
      } else {
        this.setState({
          loading: false,
        });
        const errors = Object.keys(value.errors).reduce((dic, key) => {
          dic[key] = Array.isArray(value.errors[key])
            ? value.errors[key].join("\n")
            : null;
          return dic;
        }, {});
        throw new SubmissionError(errors);
      }
    });
  };

  render = () => {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        action={this.props.action}
        method="post"
      >
        <div className="uk-margin-small">
          <Field
            name="name"
            type="text"
            component={TextInput}
            labelId="forms.attr.artist.name"
            validate={[validate.required]}
            required
            onChange={(event) =>
              this.props.onChangeName &&
              this.props.onChangeName(event.target.value)
            }
          />
        </div>

        <div
          className="uk-margin-small uk-grid-small uk-child-width-1-2@s"
          data-uk-grid
        >
          <div>
            <Field
              name="birth_place"
              type="text"
              component={TextInput}
              labelId="forms.attr.birth_place"
            />
          </div>
          <div>
            <Field
              name="activity_area"
              type="text"
              component={TextInput}
              labelId="forms.attr.activity_area"
            />
          </div>
        </div>
        <div
          className="uk-margin-small uk-grid-small uk-child-width-1-2@s"
          data-uk-grid
        >
          <div>
            <Field
              name="birth_year"
              type="number"
              component={TextInput}
              labelId="forms.attr.birth_year"
              validate={[validate.num]}
              normalize={normalize.numberOnly}
            />
          </div>
          <div>
            <Field
              name="death_year"
              type="number"
              component={TextInput}
              labelId="forms.attr.death_year"
              validate={[validate.num]}
              normalize={normalize.numberOnly}
            />
          </div>
        </div>

        <div className="uk-margin-small">
          <Field
            name="biography"
            component={Textarea}
            labelId="forms.attr.artist.biography"
            sample={<IntlHTML id="forms.samples.artist.biography" />}
          />
        </div>

        <div className="uk-margin-small">
          <Field
            name="history"
            component={Textarea}
            labelId="forms.attr.artist.history"
            sample={<IntlHTML id="forms.samples.artist.history" />}
          />
        </div>

        <div className="uk-margin-small">
          <Field
            name="priority"
            component={CheckBox}
            labelId="forms.attr.artist.represents"
          />
        </div>

        {(() => {
          if (this.props.error) {
            return (
              <div className="uk-margin-small uk-text-danger uk-text-center@s">
                <span>{this.props.error}</span>
              </div>
            );
          }
        })()}
        <div className="uk-margin uk-text-center">
          <Button
            className="uk-button uk-button-default"
            type="submit"
            disabled={this.props.invalid}
            ga={{ category: this.props.form, action: "submit" }}
            loading={this.state.loading ? 1 : 0}
          >
            <IntlText id="forms.submit" />
          </Button>
        </div>
      </form>
    );
  };
}

export default reduxForm({
  form: "gallery-artist-form",
  enableReinitialize: true,
})(ArtistForm);
